import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { from, switchMap } from 'rxjs';
import { getTokens } from '../../store/auth/auth.selector';
import { TOKEN } from '../../util/constants';


export const JwtInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) =>
{
  const store = inject(Store);

  return from(store.selectOnce(getTokens()))
    .pipe(
      switchMap((token) =>
      {
        if (!token) return next(req);

        req = req.clone({
          setHeaders: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "en",
            'Authorization': (token[TOKEN.AUTH_TOKEN] as string),
            'provider-authorization': (token[TOKEN.SHOPIFY_PROVIDER_TOKEN] as string)
          }
        });
        return next(req);
      })
    );
};
